import { axiosInstance } from 'src/util/axios.js'
import { useAuthDispatch } from 'src/contexts/authContext'

export interface IRegisterCredentials {
  firstName: string
  lastName: string
  email: string
  password: string
}

const useRegisterApi = () => {
  const dispatch = useAuthDispatch()

  const register = async ({ firstName, lastName, email, password }: IRegisterCredentials) => {
    await axiosInstance.post('/core/public/register', {
      firstName,
      lastName,
      email,
      password,
    })

    dispatch({ type: 'REGISTER' })
  }

  return { register }
}

export default useRegisterApi
